export const openMomentumInviteEmail = ({
  inviterName,
  invitationType = 'clinician',
  ministryName,
  acceptInvitationUrl = 'https://mhdfmomentum.com/login',
  expirationDate,
  recipientEmail = ''
} = {}) => {
  if (typeof window === 'undefined') {
    return;
  }

  const inviterLabel = inviterName?.trim() || 'your care team';
  const safeType = invitationType?.trim() || 'clinician';
  const expiry = expirationDate
    ? new Date(expirationDate)
    : new Date(Date.now() + 30 * 24 * 60 * 60 * 1000);
  const expiryLabel = expiry.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric'
  });

  let bodyText = '';
  if (safeType === 'clergy') {
    const ministryLabel = ministryName?.trim() || 'your faith community';
    bodyText =
      `Hi,\n\n` +
      `${inviterLabel} from ${ministryLabel} has invited you to MHDF Momentum - a daily practice companion for tending to your mental and spiritual wellbeing, one small step at a time.\n\n` +
      `Each day offers a brief, grounded rhythm across four pillars - Mind, Move, Journal, and an optional Faith track with scripture and reflection drawn from your tradition. It's a quiet, steady space to care for yourself between one Sunday and the next.\n\n` +
      `A note on privacy: ${inviterLabel} can offer encouragement and see that you're staying engaged, but your journal and personal reflections remain entirely private to you. Pastoral support, never surveillance.\n\n` +
      `And there's no way to fall behind - miss a day and Momentum simply waits for you.\n\n` +
      `Accept your invitation: ${acceptInvitationUrl}\n\n` +
      `This link is unique to you and expires on ${expiryLabel}.\n\n` +
      `Grace and peace,\n\n` +
      `- The MHDF Momentum Team`;
  } else if (safeType === 'coach') {
    bodyText =
      `Hi,\n\n` +
      `${inviterLabel} has invited you to MHDF Momentum - a daily companion for building real, lasting momentum toward the goals you're working on together.\n\n` +
      `Each day gives you a simple rhythm to return to across four pillars - Mind, Move, Journal, and an optional Faith track - plus a shared Goal Board where you and ${inviterLabel} can set intentions and track the progress that matters to you.\n\n` +
      `How it works with ${inviterLabel}: your coach can see your engagement and momentum - that you're showing up and moving forward - so they can cheer you on and adjust along the way. Your private journal and personal reflections stay yours alone.\n\n` +
      `And it's built to be forgiving: miss a day and nothing is lost. You pick right back up where you left off.\n\n` +
      `Accept your invitation: ${acceptInvitationUrl}\n\n` +
      `This link is unique to you and expires on ${expiryLabel}.\n\n` +
      `Let's build some momentum.\n\n` +
      `- The MHDF Momentum Team`;
  } else {
    bodyText =
      `Hi,\n\n` +
      `${inviterLabel} has invited you to MHDF Momentum - a daily practice companion built to support the work you're already doing together in your sessions.\n\n` +
      `Momentum gives you a small, steady rhythm to return to between appointments: a few minutes each day across four simple pillars - Mind, Move, Journal, and an optional Faith track. It isn't a replacement for your time with ${inviterLabel}; it's a way to carry that work into the hours in between, at your own pace.\n\n` +
      `A few things worth knowing:\n` +
      `- Your journal is your private space. You decide what to share, and you can grant or revoke ${inviterLabel}'s access to your progress at any time.\n` +
      `- There's nothing to fall behind on. Miss a day and the program simply waits for you - no streak to break, no penalty.\n` +
      `- You can get started in just a few minutes.\n\n` +
      `Accept your invitation: ${acceptInvitationUrl}\n\n` +
      `This link is unique to you and expires on ${expiryLabel}.\n\n` +
      `We're glad you're here.\n\n` +
      `- The MHDF Momentum Team`;
  }

  const subject = encodeURIComponent(`${inviterLabel} invited you to join MHDF Momentum`);
  const body = encodeURIComponent(bodyText);

  window.location.href = `mailto:${recipientEmail}?subject=${subject}&body=${body}`;
};
